module.exports = __webpack_public_path__ + "img/IMG_2589-2.a3ee9dd6.jpg";